export enum ResponseType {
    STATUS = 'STATUS',
    ANSWER = 'ANSWER',
    DONE = 'DONE',
    FINALIZE = 'FINALIZE',
    KNOWLEDGE_QUERY = 'KNOWLEDGE_QUERY'
}

export enum QuestionType {
    FORM = 'FORM',
    SINGLE_SELECT = 'SINGLE_SELECT',
    MULTI_SELECT = 'MULTI_SELECT',
    BOOLEAN = 'BOOLEAN',
    RADIO = 'RADIO',
    CHECKBOX = 'CHECKBOX',
    TEXT = 'TEXT',
    NUMBER = 'NUMBER'
}
